import * as Yup from "yup";
import { IUseBoolean, useBoolean } from "../../../hooks/use-boolean";
import { enqueueSnackbar } from "notistack";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ISystem, ISystemUpdate } from "../../../types/system";
import { UpdateSystemService } from "../../../services/systems";

const useSystemUpdate = (getSystems: VoidFunction, loadingTable: IUseBoolean) => {

    // hooks    
    const loadingUpdate = useBoolean(false);
    const openUpdateDialog = useBoolean();    

    // rhf
    const UpdateSystemSchema = Yup.object().shape({
        id: Yup.number().required('Informe o sistema'),
        name: Yup.string().required('Informe o nome do sistema').max(255, 'O nome deve conter no máximo 255 caracteres'),
        link: Yup.string().required('Informe o link do sistema').max(255, 'O nome deve conter no máximo 255 caracteres'),
    });    

    const methodsUpdate = useForm({
        resolver: yupResolver<ISystemUpdate>(UpdateSystemSchema),
        defaultValues: {
            id: null!,
            name: '',
            link: ''
        }
    });

    const {
        handleSubmit,
        reset,
        setValue
    } = methodsUpdate;

    // functions    
    const setValuesUpdate = (system: ISystem) => {
        setValue("id", system.id, { shouldValidate: true });
        setValue("name", system.name, { shouldValidate: true });
        setValue("link", system.link, { shouldValidate: true });

        openUpdateDialog.onTrue();
    }

    const resetValuesUpdate = () => {
        reset({
            id: null!,
            name: '',
            link: ''
        });
        openUpdateDialog.onFalse();
    }

    const onSubmitUpdate = handleSubmit(async (data: ISystem) => {

        loadingUpdate.onTrue();
        loadingTable.onTrue();

        await UpdateSystemService(data).then(resp => {
            loadingUpdate.onFalse();
            enqueueSnackbar(resp.data.message);
            resetValuesUpdate();
            getSystems();
        }).catch(error => {
            loadingUpdate.onFalse();
            loadingTable.onFalse();
            enqueueSnackbar(error?.response?.data?.message ?? 'Ocorreu um erro', {
                variant: 'error'
            });
        });

    });

    return {       
        loadingUpdate,       
        openUpdateDialog,            
        onSubmitUpdate,
        methodsUpdate,
        setValuesUpdate
    }
}

export default useSystemUpdate;